import * as React from 'react'
import { Plus } from '@phosphor-icons/react'

// Small shared UI bits for the question list, reusable across cycle types.

export function AddQuestionButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="self-start px-3 py-2 bg-white rounded-sm inline-flex items-center gap-1.5 text-gray-900 hover:bg-gray-50"
    >
      <Plus className="h-4 w-4 shrink-0" weight="bold" />
      <span className="font-talent text-base font-medium leading-5">
        Add another question
      </span>
    </button>
  )
}

export function EmptyState({ children }: { children: React.ReactNode }) {
  return (
    <div className="w-full px-4 py-6 bg-white rounded-lg border border-dashed border-gray-200 flex items-center gap-6">
      <p className="m-0 flex-1 text-center font-talent text-base font-normal text-gray-500 leading-5">
        {children}
      </p>
    </div>
  )
}
